/**
 *Retrieves the form data to use in post/get actions
 *
 * @export
 * @param {*} form
 * @returns
 */
export function getFormData(form){
    return window.FormData ? new FormData(form[0]) : form.serialize();
}